import { Image } from "@mantine/core";

/** The original Expo brand image, displayed with the same circular crop. */
export function AppLogo({ size = 72, alt = "TripBears logo" }: { size?: number; alt?: string }) {
  return (
    <Image
      src="/brand/tripbears-logo.webp"
      alt={alt}
      width={size}
      height={size}
      w={size}
      h={size}
      radius="50%"
      fit="contain"
      style={{ flexShrink: 0, border: "1px solid #000" }}
    />
  );
}
